export interface ResultsHeaderProps {
  total: number;
  zip: string;
  activeFilterCount: number;
}

export function ResultsHeader({ total, zip, activeFilterCount }: ResultsHeaderProps) {
  const advisorWord = total === 1 ? 'advisor' : 'advisors';
  const filterWord = activeFilterCount === 1 ? 'filter' : 'filters';
  const trimmedZip = zip.trim();

  return (
    <>
      <h2 className="typography-text-large mt-6 mb-2 font-semibold text-foreground">
        {total.toLocaleString()} registered {advisorWord} found near you
      </h2>
      <p className="typography-text-small mb-6 text-muted-foreground">
        Showing SEC &amp; state-registered investment advisors
        {trimmedZip ? ` near ${trimmedZip}` : ''}
        {activeFilterCount > 0
          ? ` · ${activeFilterCount.toLocaleString()} ${filterWord} applied`
          : ''}
      </p>
    </>
  );
}
